import React, {Fragment, useRef} from "react";
import { Link , NavLink} from "react-router-dom";
import {Skeleton} from "@mui/material";
import LazyLoad from "react-lazy-load";
import Grid from '@mui/material/Grid';
import customerimage from '../../../assets/images/customerimage.png';
const Home_Section_I = (props) => {
    return (


        <Fragment>


            <div className={"home-sec-i"} style={{"backgroundColor":"#f2f2f2"}} >

                <div className={"container_bk_fronts"}>

                    <Grid container direction="row" spacing={2} style={{paddingTop: "14px"}}>


                        <Grid className={"right-box-img-sec-i"} item lg={6} md={6} sm={12} xs={12}>
                            <div >
                                <h3>ارتباط بی واسطه با خریداران و فروشندگان عمده</h3>

                                <div className={"card-home-faq"}>
                                    <span className={"card-home-faq-title"}>بازارانو چیست؟ </span>
                                    <p className={"card-home-faq-desc"}>
                                        یک پلتفرم آنلاین برای خرید عمده است که به خریداران و فروشندگان امکان می‌دهد به‌صورت مستقیم و بدون واسطه با یکدیگر ارتباط برقرار کنند، بازارنو در کنار شماست از تامین تا تحویل مستقیم.
                                    </p>
                                </div>

                                <div className={"card-home-faq"}>
                                    <span className={"card-home-faq-title"}>خدمات  بازارانو به خریداران عمده</span>
                                    <p className={"card-home-faq-desc"}>
                                        شامل ارتباط مستقیم و بدون واسطه با فروشندگان عمده برای خرید عمده محصولات مورد نیاز از تامین تا تحویل مستقیم در سراسر ایران است.
                                       </p>
                                </div>


                                <div className={"card-home-faq"}>
                                    <span className={"card-home-faq-title"}> خدمات بازارانو به فروشندگان عمده</span>
                                    <p className={"card-home-faq-desc"}>
                                        با ثبت رایگان محصولات خود و استفاده از ابزارهای تبلیغاتی این پلتفرم می‌توانند به خریداران عمده دسترسی پیدا کرده و بدون واسطه اقدام به فروش و خرید عمده نمایند.
                                    </p>
                                </div>


                            </div>


                        </Grid>

                        <Grid item lg={6} md={6} sm={12} xs={12}>
                            <div  className={"left-box-img-sec-i"} >
                                <img className={"home-sec-i-image-left"} src={customerimage} alt={"logo"}/>
                            </div>
                        </Grid>


                    </Grid>
                </div>


            </div>


        </Fragment>
    );
}

export default Home_Section_I;